import script from "./GaokaoPaperDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./GaokaoPaperDetail.vue?vue&type=script&setup=true&lang=ts"

import "./GaokaoPaperDetail.vue?vue&type=style&index=0&id=428ebec2&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-428ebec2"]])

export default __exports__